// extracted by mini-css-extract-plugin
export var resolve = "resolve-module--resolve--1OdVS";
export var resolve__wrap = "resolve-module--resolve__wrap--yFtSA";
export var resolve__quote = "resolve-module--resolve__quote--10Xrm";
export var resolve__quote__content = "resolve-module--resolve__quote__content--prFVx";
export var resolve__quote__image = "resolve-module--resolve__quote__image--LzXhl";
export var resolve__quote__image__bg = "resolve-module--resolve__quote__image__bg--3ZPpK";